import { findVariantByOrigin, useCampaignContext } from '~/modules/campaign';
import { isVariantPriceDuplicated } from '../../../utils';

export interface IUsePriceProductDuplicateResult {
  /** False means the Variant has no valid duplicate yet — Preview or Start will make one. */
  isDuplicatedProduct: boolean;
}

export const usePriceProductDuplicate = (): IUsePriceProductDuplicateResult => {
  const { campaign } = useCampaignContext();

  const isDuplicatedProduct = isVariantPriceDuplicated({
    controlPrice: findVariantByOrigin(campaign, true)?.price,
    variantPrice: findVariantByOrigin(campaign, false)?.price,
  });

  return { isDuplicatedProduct };
};
